import {
  loginRespostaSchema,
  sessaoSchema,
  trocarTenantRespostaSchema,
  type Sessao,
} from "@base/contracts";
import { z } from "zod";
import type { ClienteHttp } from "../http/cliente-http";

/**
 * Porta de autenticacao no front.
 */
export interface AuthGateway {
  obterSessao(): Promise<Sessao>;
  login(email: string, senha: string): Promise<{ token: string; sessao: Sessao }>;
  refresh(): Promise<{ token: string; sessao: Sessao }>;
  logout(): Promise<void>;
  trocarTenant(tenantId: string): Promise<{ sessao: Sessao }>;
}

export class AuthGatewayHttp implements AuthGateway {
  constructor(private readonly http: ClienteHttp) {}

  async obterSessao(): Promise<Sessao> {
    return this.http.requisitar("/v1/sessao", sessaoSchema);
  }

  async login(
    email: string,
    senha: string,
  ): Promise<{ token: string; sessao: Sessao }> {
    return this.http.requisitar("/v1/auth/login", loginRespostaSchema, {
      metodo: "POST",
      corpo: { email, senha },
    });
  }

  async refresh(): Promise<{ token: string; sessao: Sessao }> {
    return this.http.requisitar("/v1/auth/refresh", loginRespostaSchema, {
      metodo: "POST",
    });
  }

  async logout(): Promise<void> {
    await this.http.requisitar("/v1/auth/logout", z.null(), {
      metodo: "POST",
    });
  }

  async trocarTenant(tenantId: string): Promise<{ sessao: Sessao }> {
    return this.http.requisitar(
      "/v1/auth/trocar-tenant",
      trocarTenantRespostaSchema,
      {
        metodo: "POST",
        corpo: { tenantId },
      },
    );
  }
}
